var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { QueryGroupApi } from '../../apis/query-group-api';
import { I18nService } from '@/services/i18n-service';
let QueryGroupRepositoryImpl = class QueryGroupRepositoryImpl {
    constructor(_queryGroupApi, _i18nService) {
        this._queryGroupApi = _queryGroupApi;
        this._i18nService = _i18nService;
    }
    async queryGroup(options) {
        const page = options.page;
        const limit = 20;
        const request = {
            name: options.name,
            page,
            limit,
        };
        const response = await this._queryGroupApi.queryGroup(request);
        let records = response.records;
        const total = response.total;
        if (!options.containsAllowExternalMemberGroup) {
            records = this._filterAllowExternalMemberGroup(records);
        }
        if (!options.containsVirtualGroup) {
            records = this._filterVirtualGroup(records);
        }
        else {
            records = records.map(this._replaceVirtualGroupName.bind(this));
        }
        return {
            records,
            page: options.page,
            total,
            diff: response.records.length - records.length,
        };
    }
    _replaceVirtualGroupName(record) {
        if (record.is_virtual_group) {
            record.name = this._i18nService.t('workspace.publicGroup.all');
        }
        return record;
    }
    _filterAllowExternalMemberGroup(records) {
        return records.filter(record => !record.allow_external);
    }
    _filterVirtualGroup(records) {
        return records.filter(record => !record.is_virtual_group);
    }
};
QueryGroupRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(QueryGroupApi)),
    __param(1, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof QueryGroupApi !== "undefined" && QueryGroupApi) === "function" ? _a : Object, typeof (_b = typeof I18nService !== "undefined" && I18nService) === "function" ? _b : Object])
], QueryGroupRepositoryImpl);
export { QueryGroupRepositoryImpl };
